import magnifiAPIInstance from "./apiInstance";

export const clipListAPIs = {
  getClipLists: ({ payload }) => magnifiAPIInstance.get(`/get_folders_by_entityId`, payload),
  updateClipList: ({ clipListId, payload }) => magnifiAPIInstance.post(`/update-folder/${clipListId}`, payload),
  getStreamClipLists: ({ payload, params }) => magnifiAPIInstance.post(`/get-all-folders`, payload, { params }),
  deleteClipList: ({ clipListId, payload }) => magnifiAPIInstance.delete(`/delete-folder/${clipListId}`, payload),
  exportClipListJSON: ({ payload }) => magnifiAPIInstance.post(`/export_clip_json`, payload),
  getAdvancedEditorDetails: ({ payload }) => magnifiAPIInstance.post(`/advanceEditorIllusto`, payload),
  createClipListFolder: (payload) => magnifiAPIInstance.post("/folder", payload),
  updateClipListFolder: ({ clipListId, payload }) =>
    magnifiAPIInstance.post(`update-highlight-folder/${clipListId}`, payload),
  getClipListDetails: ({ clipListId, payload }) => magnifiAPIInstance.get(`/folder/${clipListId}`, payload),
  generateHighlightPreview: ({ payload }) => magnifiAPIInstance.post(`/create-preview`, payload),
  generateSocialMediaCaptionForHighlight: ({ payload }) =>
    magnifiAPIInstance.post(`/api/v3/social_media_captions/highlight`, payload),
};
